export default "__VITE_ASSET__D$Uf6yHT__"